'use strict';

module.exports = require('./components/column/Column');